// Core
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import WidgetTotalHeader from '../../../components/WidgetTotalHeader';
import StatsLoader from '../../../components/StatsLoader';

// Other
import graphColours from 'constants/graphColours';

function MessagesSentAnalysis(props) {
  const messagesSentBySource = useSelector(
    (state) => state.statsRoute.messagesSentBySource
  );
  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingMessagesSentSourceStats
  );

  let totalSentMessages = 0;

  const sourceMap = {
    chatgpt: 'ChatGPT',
    watson: 'IBM Watson',
  };

  let data = messagesSentBySource
    .map((data) => {
      totalSentMessages += data.value;
      return [sourceMap[data.source] || 'Agent', data.value];
    })
    .filter(Boolean)
    .sort(([a], [b]) => a.localeCompare(b));

  const header = ['Source', 'Number of Messages'];
  const graphData = data.length ? [header, ...data] : [header, ['', 0]];

  const graphOptions = {
    legend: { position: 'bottom' },
    tooltip: { isHtml: true },
    focusTarget: 'category',
    colors: !data.length
      ? undefined
      : [
          data.some(([source]) => source === 'Agent')
            ? graphColours.primary
            : null,
          data.some(([source]) => source === 'ChatGPT')
            ? graphColours.tertiary
            : null,
          data.some(([source]) => source === 'IBM Watson')
            ? graphColours.secondary
            : null,
        ].filter(Boolean),
  };

  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <WidgetTotalHeader
              primary={totalSentMessages}
              suffix={
                <span style={{ fontSize: '14px' }}>
                  {'Total Sent Messages'}
                </span>
              }
              showSecondary={false}
            />
          </div>
        </GeckoRow>

        <GeckoRow>
          <div className="col">
            <Chart
              chartType="PieChart"
              data={graphData}
              options={graphOptions}
              graph_id={props.id}
              width="100%"
              height="400px"
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
}

export default MessagesSentAnalysis;
